/**
 * Centralized API configuration for Charitage Foundation
 * Ensures API base URL always points to /api without double slashes or duplicated /api paths.
 */

const getApiBaseUrl = () => {
  // If running in browser and NOT on localhost, always use relative origin /api
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname;
    if (host !== 'localhost' && host !== '127.0.0.1') {
      return `${window.location.origin}/api`;
    }
  }

  const envUrl = (process.env.REACT_APP_BACKEND_URL || '').trim().replace(/\/+$/, '');

  // Default to production domain if not specified
  if (!envUrl) {
    return 'https://charitage.org/api';
  }

  // If already ends with /api, return as is; otherwise append /api
  return envUrl.endsWith('/api') ? envUrl : `${envUrl}/api`;
};

export const API_URL = getApiBaseUrl();
export default API_URL;
